import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { signOut } from '../../supabase/auth';
import {
  FaTachometerAlt,
  FaUsersCog,
  FaWallet,
  FaClipboardList,
  FaBook,
  FaFileAlt,
  FaFolder,
  FaUsers,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaList
} from 'react-icons/fa';
import logo from '../../assets/images/logo.png';

const Sidebar = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      // Handle error silently or show user-friendly message
    }
  };

  const adminLinks = [
    { to: "/admin/dashboard", icon: <FaTachometerAlt />, text: "Dashboard" },
    { to: "/admin/semua-pesanan", icon: <FaClipboardList />, text: "Daftar Pesanan" },
    { to: "/admin/daftar-pelanggan", icon: <FaUsers />, text: "Daftar Pelanggan" },
    { to: "/admin/database-buku", icon: <FaBook />, text: "Database Buku" },
    { to: "/admin/manajemen-kategori", icon: <FaList />, text: "Kategori Buku" },
    { to: "/admin/manajemen-komisi", icon: <FaWallet />, text: "Manajemen Komisi" },
    { to: "/admin/manajemen-mitra", icon: <FaUsersCog />, text: "Manajemen Mitra" },
    { to: "/admin/manajemen-materi", icon: <FaFolder />, text: "Manajemen Materi" },
  ];

  const mitraLinks = [
    { to: "/mitra/dashboard", icon: <FaTachometerAlt />, text: "Dashboard" },
    { to: "/mitra/riwayat-pesanan", icon: <FaClipboardList />, text: "Daftar Pesanan" },
    { to: "/mitra/daftar-buku", icon: <FaBook />, text: "Daftar Buku" },
    { to: "/mitra/daftar-pelanggan", icon: <FaUsers />, text: "Daftar Pelanggan" },
    { to: "/mitra/komisi", icon: <FaWallet />, text: "Lihat Komisi" },
    { to: "/mitra/materi", icon: <FaFileAlt />, text: "Materi Mitra" },
  ];

  const links = currentUser?.role === 'admin' ? adminLinks : mitraLinks;

  return (
    <aside className={`${isCollapsed ? 'w-20' : 'w-64'} bg-white flex-shrink-0 border-r border-gray-200 flex flex-col transition-all duration-300 ease-in-out`}>
      {/* Header with toggle button */}
      <div className={`h-20 flex items-center ${isCollapsed ? 'justify-center' : 'justify-between'} px-4 border-b border-gray-200`}>
        {!isCollapsed && (
          <div className="flex items-center">
            <img src={logo} alt="Logo" className="h-10" />
            <span className="ml-3 text-xl font-bold text-gray-800">Nur Hidayah Press</span>
          </div>
        )}
        {isCollapsed && <img src={logo} alt="Logo" className="h-10" />}
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-lg hover:bg-gray-100 text-gray-600 hover:text-gray-900 transition-colors duration-200"
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? <FaBars className="text-lg" /> : <FaTimes className="text-lg" />}
        </button>
      </div>
      
      {/* Navigation */}
      <nav className="flex-grow p-4">
        <ul>
          {links.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                className={({ isActive }) =>
                  `flex items-center ${isCollapsed ? 'justify-center' : 'gap-4'} px-4 py-3 my-1 rounded-lg text-gray-600 font-semibold transition-all duration-200 hover:bg-gray-100 hover:text-gray-900 group relative ${
                    isActive 
                    ? 'bg-amber-500 text-white shadow-lg hover:bg-amber-600 hover:text-white' 
                    : ''
                  }`
                }
                title={isCollapsed ? link.text : ''}
              >
                <span className="text-lg">{link.icon}</span>
                {!isCollapsed && <span>{link.text}</span>}
                
                {/* Tooltip for collapsed state */}
                {isCollapsed && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50">
                    {link.text}
                  </div>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      
      {/* Logout button */}
      <div className="p-4 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className={`w-full flex items-center ${isCollapsed ? 'justify-center' : 'gap-4'} px-4 py-3 rounded-lg text-red-500 font-semibold transition-all duration-200 hover:bg-red-50 group relative`}
          title={isCollapsed ? 'Logout' : ''}
        >
          <span className="text-lg"><FaSignOutAlt /></span>
          {!isCollapsed && <span>Logout</span>}
          
          {/* Tooltip for collapsed state */}
          {isCollapsed && (
            <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50">
              Logout
            </div>
          )}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
